import { Box, Typography, ButtonBase } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import CommentIdWithTooltip from './CommentIdWithTooltip';
import { SystemPromptHeaderProps } from '../types';
import { ExpandIconBox } from '../../styled';

const SystemPromptHeader = ({ eventData, expanded, onToggle }: SystemPromptHeaderProps) => (
    <ButtonBase
        onClick={onToggle}
        sx={{ width: '100%', textAlign: 'left', display: 'block', p: 0, borderRadius: 1 }}
        disableRipple
    >
        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
            <Typography variant="subtitle2" fontWeight="bold" sx={{ display: 'inline', mr: 1 }}>
                System Instructions
            </Typography>
            {eventData?.audit_log?.comment_id && <CommentIdWithTooltip commentId={eventData.audit_log.comment_id} />}
            <ExpandIconBox>{expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}</ExpandIconBox>
        </Box>
    </ButtonBase>
);

export default SystemPromptHeader;
